import { Subject, merge } from 'rxjs'
import { map, switchMap, share, debounceTime, startWith } from 'rxjs/operators'
import { Resize, Scroll } from 'front-end-core/services/WindowService'
import { getBoundingClientRect, getPathTo, isParentOf } from 'front-end-core/helpers/document'
import content from 'static/help.xml'
import { toJson } from 'front-end-core/helpers/xml'
import { result, trim, uniqBy, zipObject } from 'libraries/lodash'

const contentParsed = toJson(content(), ['helpitem'])
const contentMap = zipObject(contentParsed.map(i => i.attributes.name), contentParsed.map(i => trim(i.content)))

const OverlayTrigger = new Subject()

const mapElement = function ({ _bottom, _left, _right, _top, target }, el) {
  const { bottom, height, left, right, top, width } = getBoundingClientRect(el)
  const { helpItem: itemName = null, helpPosition: position = 'bottom' } = el.dataset
  const isFocused = target ? isParentOf(el, target) : false

  if (
    itemName === null ||
    !contentMap.hasOwnProperty(itemName) || // eslint-disable-line
    top < _top ||
    bottom > _bottom ||
    left < _left ||
    right > _right
  ) {
    return null
  }
  return { bottom, height, item: contentMap[itemName], itemName, left, position, right, top, width, isFocused }
}

const filterItem = function (s) {
  return (
    !!s &&
    s.width !== 0 &&
    s.height !== 0
  )
}

const getHelpItems = function (e) {
  const target = result(e, 'target', null)
  const { bottom: _bottom, left: _left, right: _right, top: _top } = getBoundingClientRect(document.querySelector('#application-content'))
  return [
    ...[...document.querySelectorAll('#application-content [data-help-item]')].map(mapElement.bind(null, { _bottom, _left, _right, _top, target })),
    ...[...document.querySelectorAll('#application-header [data-help-item]')].map(mapElement.bind(null, { _bottom: window.innerHeight, _left: 0, _right: window.innerWidth, _top: 0, target })).reverse()
  ]
}

const findFocused = function (items) {
  return items.reduce((a, v, i) => (v.isFocused && i) || a, 0)
}

export const showOverlay = OverlayTrigger.next.bind(OverlayTrigger)
export const hideOverlay = OverlayTrigger.next.bind(OverlayTrigger, null)
export const OverlayItems = OverlayTrigger.pipe(
  switchMap(e => merge(Resize.pipe(debounceTime(500)), Scroll).pipe(startWith(true), map(x => e))),
  map(e => e !== null ? uniqBy(getHelpItems(e).filter(filterItem), 'itemName') : []),
  map(items => ({ items, show: findFocused(items) }))
)

export const PopoverTrigger = new Subject().pipe(share())
const triggerPopover = function (contentMap, persist, el) {
  return PopoverTrigger.source.next(Object.assign({ key: getPathTo(el), content: contentMap(el), persist, dismiss: false, el }))
}
export const triggerPopoverItem = ({ name: propName = 'popoverItem', persist = true }) => triggerPopover.bind(null, el => contentMap[el.dataset[propName]], persist)
export const triggerPopoverContent = ({ name: propName = 'popoverContent', persist = true }) => triggerPopover.bind(null, el => el.dataset[propName], persist)
export const dismissPopover = (target) => PopoverTrigger.source.next({ dismiss: true, persist: true, target })
